import apiBase from "./apiBase";

export default {
  initializeKiosk: async (serialNumber) => {
    let response = await apiBase.callService(
      "Kiosk/Initialize?apiKey=" + serialNumber,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
  getAssignedExaminee: async (serialNumber) => {
    let response = await apiBase.callService(
      "Kiosk/AssignedExamineeInfo?apiKey=" + serialNumber,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
};
